/* eslint-disable max-lines-per-function */
import React, { useEffect } from "react"
import QuizPanel from "../../../components/Quiz/QuizPanel"
import { skin } from "../../../styles/skin"
import { Wrapper } from "./styled"
import { useDispatch, useSelector } from "react-redux"
import { gameInfoUpdate } from "/src/redux/actions/gameActions"
import whiteQkLogo from "../../../../media/quiz_kit_logo_white.svg"


const Question = () => {
  const game = useSelector(state => state.game)
  const dispatch = useDispatch()

  // Decreases timeRemaining by 1 sec until timer reaches 0
  // Re-renders every time timeRemaining changes
  // Use setTimout to ensure timeRemaining is decremented every second
  useEffect(() => {
    setTimeout(() => {
      if (game.countdown.isStarted && game.countdown.timeRemaining > 0) {
        dispatch(gameInfoUpdate("timeRemaining", Math.max(game.countdown.timeRemaining - 0.033, 0)))
      }
    }, 33)
  }, [game.countdown.isStarted, game.countdown.timeRemaining])

  return (
    <Wrapper>
      <QuizPanel 
        answersSelectedBy={game.answersSelectedBy}
        bannerImage={game.skin.bannerImage}
        colors={{
          background: game.skin.colors.background,
          correctBackground: game.skin.colors.correctBackground,
          correctForeground: game.skin.colors.correctForeground,
          highlight: game.skin.colors.highlight,
          incorrectColor: game.skin.colors.incorrect,
          primary: game.skin.colors.primary,
          primaryFont: game.skin.colors.primaryFont,
          secondary: game.skin.colors.secondary,
          secondaryFont: game.skin.colors.secondaryFont,
          timerBackground: game.skin.colors.background,
          variables: game.skin.colors.variables,
          wrongBackground: game.skin.colors.wrongBackground,
          wrongForeground: game.skin.colors.wrongForeground
        }}
        countdown={{
          startTime: game.countdown.startTime,
          timeRemaining: game.countdown.timeRemaining
        }}
        fonts={{
          primaryFont: game.skin.primaryFont,
          secondaryFont: game.skin.secondaryFont
        }}
        isRevealed={game.isRevealed}
        question={game.question}
        skinName={game.skin.name}
      />
    </Wrapper>
  )
}

export default Question